document.addEventListener('DOMContentLoaded', function(event) {
   gsap.registerPlugin(ScrollTrigger);
   gsap.registerPlugin(CSSPlugin);


    var defyRight = document.querySelector('.defy-kb--right');
    var defyLeft = document.querySelector('.defy-kb--left');
    var columnarTitle = document.querySelector('#columanrTitle');
    var columnarContent = document.querySelector('#columnarContent');

    var offsetTextY = - (defyRight.offsetHeight / 3);
  

    //.to(columnarTitle, {autoAlpha: 0, x: -124, duration: 1})
    //.to(columnarContent, {autoAlpha: 0, x: -124, duration: 1}, "-=0.5")
    //.to(defyRight, {x: window.innerWidth, autoAlpha: 0, duration: 2}, "-=1")
    //.to(defyLeft, {x: - window.innerWidth, autoAlpha: 0, duration: 2}, "-=2");

    ScrollTrigger.matchMedia({
      "(min-width: 820px)" : function() {
        var tlColumnar = gsap.timeline({
          scrollTrigger: {
              trigger: ".defy-columnar-layout",
              markers: false,
              start: "top top",
              end: "bottom bottom",
              pin: true,
              scrub: 1,
              pinSpacing: true
            }
        });
        gsap.set(defyLeft, {rotation: -10, y: -defyRight.offsetHeight / 4});
        gsap.set(defyRight, {rotation: 10, y: defyRight.offsetHeight / 2});
        gsap.set(columnarTitle, {autoAlpha: 0, x: -124, y: offsetTextY});
        gsap.set(columnarContent, {autoAlpha: 0, x: -124, y: offsetTextY});
        tlColumnar
        .to(defyLeft, {y: 0, duration: 3, ease: "power2.inOut"})
        .to(defyRight, {y: 0, duration: 3, ease: "power2.inOut"}, "-=3")
        .to(columnarTitle, {autoAlpha: 1, x: 0, duration: 1, ease: "power2.inOut"})
        .to(columnarContent, {autoAlpha: 1, x: 0, duration: 1, ease: "power2.inOut"}, "-=0.5")
        .to(defyRight, {rotation: 2, duration: 2, ease: "power2.inOut"}, "-=1")
        .to(defyLeft, {rotation: -2, duration: 2, ease: "power2.inOut"}, "-=2");
      }
    });

});